import { PasswordConfig } from "../models/SecurityPolicyPasswordConfig";
import { getSecurityPolicyById } from "../services/securityPolicyService";

export class SecurityPolicyHelper {
    static async fetchSecurityPolicyPasswordConfig(securityPolicyId: number, translate): Promise<PasswordConfig | null> {
        if (securityPolicyId && securityPolicyId !== 0) {
            const securityPolicy = await getSecurityPolicyById(securityPolicyId + "", translate);
            return {
                enforceUppercase: securityPolicy.enforceUppercase,
                enforceLowercase: securityPolicy.enforceLowercase,
                enforceDigits: securityPolicy.enforceDigits,
                enforceSpecialCharacters: securityPolicy.enforceSpecialCharacters,
                enforcePasswordMinLength: securityPolicy.enforcePasswordMinLength,
                passwordMinLength: securityPolicy.passwordMinLength,
            };
        }
        return null;
    }
}
